import call from './index'

//获取列表
export const sysAccountList = data => {
	return call('admin/client/search', data, 'get')
}
export const upSwitch = data => {
	return call('admin/client/interface_switch', data)
}

export const sysCreateAccount = data => {
	return call('admin/client/add', data)
}

export const batchUpdateStatus = data => {
	return call('admin/client/status', data)
}

export const getCode = data => {
	return call('admin/client/code', data)
}
export const chargeMoneyData = data => {
	return call('admin/client/recharge', data)
}

export function passwordupdate(data) {
	return call(`admin/client/up_password`, data)
}

export function addProfitData(data) {
	return call(`admin/client/add_profit `, data)
}

export const recordList = data => {
	return call('admin/client/record_list', data, 'get')
}

export const getClient = data => {
	return call('admin/client/get_client', data, 'post')
}

export function cleanTokenData(data) {
	return call(`admin/client/eliminate`, data)
}
